import React from "react";
import PageWithConfigurator from "../global/pageWithConfigurator/pageWithConfigurator";

import StaffSalesModule from "./sales/index";
import ActivitiesModule from "./activities/index";

const pageConfig = {
  pageName: "Staff Activity",
  configuratorWidth: 375,
  moduleList: [StaffSalesModule, ActivitiesModule]
};

const StaffActivityPage = ({ notifications }) => (
  <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />
);

export default StaffActivityPage;
